import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TableComponent from "../../../../atoms/TableComponent/DataTable";
import axiosInstance from "../../../../lib/axios";
import { usePermissions } from "../../../../GlobalFunction/userPermissions";
import { Button, Tooltip ,Box } from "@mui/material";

const columns = [
  { id: "RowNum", label: "Sr.No.", minWidth: 5 },
  { id: "TktCategoryName", label: "CategoryName", minWidth: 100 },
  {id:"ServiceProvNm", label: "ServProv", minWidth:100},
  { id: "Abrv", label: "Abrv", minWidth: 100 },
  { id: "Remark", label: "Remark", minWidth: 100 },
  { id: "Status", label: "Status", minWidth: 50 },
];

export default function CatWiseServProvListTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [searchTerms, setSearchTerms] = useState({});
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  const permissions = usePermissions("Ticket Category");
  const { AddRec = "0" } = permissions || {};

  // New function to handle click based on permission
  const handlePermittedClick = () => {
    if (AddRec === "1") {
      handleClick();
    }
  };

  useEffect(() => {
    fetchComplaintTypeData();
  }, []);

  const fetchComplaintTypeData = async () => {
    try {
      const response = await axiosInstance.post(
        "TktCategory/getTktCategoryDashBoard",
        {
          start: 1,
          PageSize: 1,
          SearchText: "Dtl",
        }
      );

      if (response.data.Status === 0) {
        const formattedData = response.data.Data.map((complaintType) => ({
          ...complaintType,
          RowNum: complaintType.RowNum,
          TktCategoryName: complaintType.TktCategoryName || "",
          Abrv: complaintType.Abrv,
          Remark: complaintType.Remark,
          Status:
            complaintType.Status === null
              ? ""
              : complaintType.Status == "1"
              ? "Active"
              : "Inactive",
        }));
        console.log("formattedData", formattedData);
        setRows(formattedData);
        console.log("data", response);
      } else {
        console.error(
          "Error fetching complaintType master data:",
          response.data.Message
        );
      }
    } catch (error) {
      console.error("Error fetching complaintType master data:", error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleClick = () => {
      navigate("/ticket-category");
  };

  const handleHomeClick = () => {
    navigate("/dashboard");
  };

  const handleSearchChange = (columnId, value) => {
    setSearchTerms((prev) => ({ ...prev, [columnId]: value }));
    setPage(0);
  };

  const filteredRows = React.useMemo(() => {
    return rows.filter((row) => {
      return Object.entries(searchTerms).every(([columnId, term]) => {
        if (!term) return true;
        const value = row[columnId];
        if (typeof value === "string") {
          return value.toLowerCase().includes(term.toLowerCase());
        } else if (typeof value === "number") {
          return value.toString().includes(term);
        }
        return true;
      });
    });
  }, [searchTerms, rows]);

  const handleRowDoubleClick = (row) => {
    navigate("/ticket-category", {
      state: { TktCategoryId: row.TktCategoryId, mode: "view" },
    });
  };
  const handleLocationclick = () => {
    navigate("/masters/ticketing");
  };
  const addButtonStyles = {
    background: AddRec === "1" ? "#635bff" : "rgba(0, 0, 0, 0.12)",
    color: AddRec === "1" ? "white" : "rgba(0, 0, 0, 0.26)",
    borderRadius: "50px",
    padding: "8px 20px",
    boxShadow: AddRec === "1" ? "0px 6px 15px rgba(0, 0, 0, 0.3)" : "none",
    transition: "background 0.3s ease",
    "&:hover": {
      background: AddRec === "1" ? "#524ccc" : "rgba(0, 0, 0, 0.12)"
    },
    "&:disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      color: "rgba(0, 0, 0, 0.26)"
    }
  };
  const Filters = (
    <Box  sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <Tooltip 
        title={AddRec !== "1" ? "You have no permission to add record" : ""}
        placement="top"
      >
        <span> 
          <Button
            variant="contained"
            onClick={handlePermittedClick}
            size="small"
            disabled={AddRec !== "1"}
            sx={addButtonStyles}
          >
            Add New Record
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
  return (
    <TableComponent
      columns={columns}
      rows={rows}
      filteredRows={filteredRows}
      FiltersJsx={Filters}
      page={page}
      title="Ticketing"
      titleMaster="Ticket Category Master"
      rowsPerPage={rowsPerPage}
      handleRowDoubleClick={handleRowDoubleClick}
      handleSearchChange={handleSearchChange}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      handleClick={handleClick}
      handleHomeClick={handleHomeClick}
      handleLocationclick={handleLocationclick}
    />
  );
}
